document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll("[data-da-video]");

  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector(".da-video__el");
    const playBtn = wrapper.querySelector(".da-video__btn--play");
    const replayBtn = wrapper.querySelector(".da-video__btn--replay");
    const fsBtn = wrapper.querySelector(".da-video__btn--fs");
    const soundBtn = wrapper.querySelector(".da-video__sound-btn");

    if (!video) return;

    function setOrientation() {
      const vw = video.videoWidth || 0;
      const vh = video.videoHeight || 0;
      if (!vw || !vh) return;

      wrapper.classList.remove("da-portrait", "da-landscape");

      if (vh > vw) {
        wrapper.classList.add("da-portrait");
        wrapper.setAttribute("data-orientation", "portrait");
      } else {
        wrapper.classList.add("da-landscape");
        wrapper.setAttribute("data-orientation", "landscape");
      }
    }

    function showPlay() {
      if (playBtn) playBtn.style.display = "inline-flex";
    }

    function hidePlay() {
      if (playBtn) playBtn.style.display = "none";
    }

    function showReplay() {
      wrapper.classList.add("da-ended");
      if (replayBtn) replayBtn.style.display = "inline-flex";
    }

    function hideReplay() {
      wrapper.classList.remove("da-ended");
      if (replayBtn) replayBtn.style.display = "none";
    }

    function updateSoundButton() {
      if (!soundBtn) return;
      soundBtn.textContent = video.muted ? "Tap for sound" : "Sound on";
    }

    function safePlay() {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise
          .then(() => {
            hidePlay();
            hideReplay();
          })
          .catch(() => {
            showPlay();
          });
      }
    }

    function attemptAutoplay() {
      const shouldAutoplay = wrapper.dataset.daAutoplay === "true";
      if (!shouldAutoplay) {
        showPlay();
        return;
      }

      video.muted = true;
      video.playsInline = true;
      video.setAttribute("muted", "muted");
      video.setAttribute("playsinline", "playsinline");
      video.setAttribute("preload", "preload");
      

      safePlay();
    }

    video.addEventListener("loadedmetadata", () => {
      setOrientation();
      updateSoundButton();
      video.classList.add("is-ready");
      attemptAutoplay();
    });

    video.addEventListener("canplay", () => {
      video.classList.add("is-ready");
    });

    video.addEventListener("play", () => {
      hidePlay();
      hideReplay();
    });

    video.addEventListener("pause", () => {
      if (!video.ended) showPlay();
    });

    video.addEventListener("ended", () => {
      showReplay();
    });

    if (playBtn) {
      playBtn.addEventListener("click", () => {
        safePlay();
      });
    }

    if (replayBtn) {
      replayBtn.addEventListener("click", () => {
        video.currentTime = 0;
        safePlay();
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener("click", () => {
        video.muted = !video.muted;
        updateSoundButton();
        if (video.paused) safePlay();
      });
    }

    if (fsBtn) {
      fsBtn.addEventListener("click", () => {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (wrapper.requestFullscreen) {
          wrapper.requestFullscreen();
        }
      });
    }

    video.addEventListener("click", () => {
      if (video.paused) {
        safePlay();
      } else {
        video.pause();
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const shouldAutoplay = wrapper.dataset.daAutoplay === "true";
          if (!shouldAutoplay) return;

          if (entry.isIntersecting) {
            if (video.paused && !video.ended) {
              video.muted = true;
              updateSoundButton();
              safePlay();
            }
          } else {
            if (!video.paused && !video.ended) {
              video.pause();
            }
          }
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(wrapper);

    if (video.readyState >= 1) {
      setOrientation();
      updateSoundButton();
      attemptAutoplay();
    }
  });
});